import { create } from "@storybook/theming/create";

export default create({
  base: "dark",
  brandTitle: "React Supamenu",
  brandUrl: "https://github.com/simonpatrat/react-supamenu",
  brandImage: "./images/supamenu-logo-1.svg",
  brandTarget: "_self",
});
